// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import App from './App'
//import BootstrapVue from 'bootstrap-vue'
//import 'bootstrap/dist/css/bootstrap.css'
//import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'popper.js'

Vue.config.productionTip = false;
Vue.use(VueAxios, axios);

/* eslint-disable no-new */
//root Vue instance. Constructor function.
//A Vue insance is a ViewModel (MVVM)
new Vue({
  el: '#app',
  components: { App },
  template: '<App/>',
  data: {
    characters: {}
  },
  methods: {
    
  }

})



// WEBPACK FOOTER //
// ./src/main.js